import { format } from "date-fns";

import type { IEndDateLimits } from "@/@types/campaign";
import type { CampaignConflictItem } from "./conflict-resolution";

const DAY_KEY_FORMAT: string = "yyyy-MM-dd";
const HTTP_CONFLICT: number = 409;

interface EndCampaignFailure {
  status?: number;
  data?: { conflicts?: CampaignConflictItem[] };
}

export function toDayKey(value: string | Date): string {
  return format(new Date(value), DAY_KEY_FORMAT);
}

export function endsAfterToday(endDate: string): boolean {
  return toDayKey(endDate) > toDayKey(new Date());
}

export function endDateLimitsOf(
  startDate: string,
  currentEndDate: string,
): IEndDateLimits {
  return {
    today: toDayKey(new Date()),
    startDay: toDayKey(startDate),
    currentEndDay: toDayKey(currentEndDate),
  };
}

export function conflictsOf(failure: unknown): CampaignConflictItem[] {
  const typed: EndCampaignFailure = (failure ?? {}) as EndCampaignFailure;
  if (typed.status !== HTTP_CONFLICT) return [];
  return typed.data?.conflicts ?? [];
}
